import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Op native (Capacitor): systeem in-app browser (SFSafariViewController / Chrome Custom Tabs).
 * In de browser: nieuw tabblad.
 */
export async function openExternalUrl(url: string): Promise<void> {
  const u = url?.trim();
  if (!u) return;
  if (Capacitor.isNativePlatform()) {
    await Browser.open({
      url: u,
      presentationStyle: 'fullscreen',
      toolbarColor: '#0A2342',
    });
    return;
  }
  window.open(u, '_blank', 'noopener,noreferrer');
}
